export class SparkJob {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "sparkEngineId",
            "baseName": "sparkEngineId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "sparkEngineName",
            "baseName": "sparkEngineName",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "SparkJobStatus",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "jobTimeout",
            "baseName": "jobTimeout",
            "type": "number",
            "format": ""
        },
        {
            "name": "retryPolicy",
            "baseName": "retryPolicy",
            "type": "SparkJobRetryPolicy",
            "format": ""
        },
        {
            "name": "sparkSubmitParams",
            "baseName": "sparkSubmitParams",
            "type": "SparkJobSparkSubmitParams",
            "format": ""
        },
        {
            "name": "requestedSource",
            "baseName": "requestedSource",
            "type": "SparkJobSource",
            "format": ""
        },
        {
            "name": "resolvedSource",
            "baseName": "resolvedSource",
            "type": "ResolvedRepositorySource",
            "format": ""
        },
        {
            "name": "storageConfig",
            "baseName": "storageConfig",
            "type": "StorageConfig",
            "format": ""
        },
        {
            "name": "comet",
            "baseName": "comet",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sparkApplicationId",
            "baseName": "sparkApplicationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "attempts",
            "baseName": "attempts",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SparkJob.attributeTypeMap;
    }
    constructor() {
    }
}
